module.exports = __webpack_public_path__ + "static/cd_cases-b5cb3f294100924924a5358964259e21.jpg";